import { takeEvery, call, put } from 'redux-saga/effects';
import {GET_ALL_OUTLETS, SET_ALL_OUTLETS } from '../actions';
import { apiUrlV2} from "../components/Helpers/Config";
import Axios from 'axios';
import {reactLocalStorage} from 'reactjs-localstorage';

export const watchGetAllOutlets = function* () {
  yield takeEvery(GET_ALL_OUTLETS, workerGetAllOutlets);
}

function* workerGetAllOutlets({ availability }) {
  try {

  var app_id  =  reactLocalStorage.get("app_id") !== "" && reactLocalStorage.get("app_id") !== undefined && reactLocalStorage.get("app_id") !== null
      ? reactLocalStorage.get("app_id")
      : "";     

  const uri = apiUrlV2+'outlets/getAllOutles?app_id='+app_id;
  const result = yield call(Axios.get, uri);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_ALL_OUTLETS, value: resultArr });
  } 
  catch {
    console.log('Get All Outlets Failed');
  }
} 
